module.exports = __webpack_public_path__ + "static/media/foto.9daaee0f.png";